/* globals jQuery, wordpress_globals */

import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import CookieMenu from './modules/cookie_menu';
import Menu from './modules/menu';
import Dropdown from './modules/dropdown';
import ListSplit from './modules/list_split';
import Accordion from './modules/accordion';
import InfoButtons from './modules/info_button';
import MapPopover from './modules/map_popover';
import TextArea from './modules/text_area';
import StickyMenu from './modules/sticky_menu';
import WPAjax from './modules/wp_ajax';
import GetConnected from './modules/get_connected';
import ArticleSignUp from './modules/article-sign-up';
import LEAS from './modules/leas';
import Locations from './modules/locations';
import LocationsKML from './modules/locations_kml';
import TableSort from './modules/table_sort';
import RegisterModal from './modules/register_modal';
import Blog from './modules/blog';
import MobileTable from './modules/mobile_table';
import Register from './modules/register';
import MultiDropdown from './modules/multi_dropdown';
import Login from './modules/login';
import ScrollButtons from './modules/scroll_buttons';
import ProfilePicturePreview from './modules/profile_picture_preview';
import LineClamp from './modules/line_clamp';
import _  from 'lodash';
import LogoGrid from './modules/logo_grid';
import WOW from 'wow.js';
import { CountUp } from 'countup.js';
import Header from './modules/header';
import FeatureGrid from './modules/feature_grid';
import Key from './modules/key';
import TableInfo from './modules/table_info';
import BackToTop from './modules/back_to_top';
import NetworkMasonry from './modules/network_masonry';
import Popup from './modules/popup';
import Search from './modules/search'
import Cookies from 'js-cookie';
import Mark from "mark.js";
import Ajax from "./modules/ajax/Ajax";

window.namespace = {
	init: function() {
		if(typeof NodeList.prototype.forEach !== 'function'){
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		Search.init();
		//Add standard class to caldera form validation and fix errorContainer to handle class change
		// window.Parsley.on('form:init', form => {
		// 	form.options.errorTemplate = '<span></span>';
		// 	form.options.errorsWrapper = '<span class="form__validation help-block caldera_ajax_error_block"></span>';
		// 	form.options.errorWrapper = '<span></span>';
		// 	form.options.errorsContainer = field => field.$element.closest('.form__group');
		// });

		var wow = new WOW(
            {
                boxClass: 'wow',
                animateClass: 'animation_complete',
                offset: 0,
                mobile: true,
                live: true,
                callback: (box) => {
					// if(box.classList.contains('stat')) {
					// 	let stat_content = box.querySelector('[data-number]')
					// 	let stat = stat_content.dataset.number;
					// 	let args = {
					// 		duration: 2.6,
					// 		easingFn: function (t, b, c, d) {
					// 			let ts = (t /= d) * t,
					// 				tc = ts * t;

					// 			return b + c * (tc + -3 * ts + 3 * t);
					// 		}
					// 	};

					// 	let number = stat_content.dataset.number.replace(/[^\d\.\-]/g, "");

					// 	args.decimalPlaces = (number.indexOf('.') === -1) ? 0 : number.split('.')[1].length;

					// 	if(typeof stat_content.dataset.prefix !== 'undefined'){
					// 		args.prefix = stat_content.dataset.prefix;
					// 	}
					// 	if(typeof stat_content.dataset.suffix !== 'undefined'){
					// 		args.suffix = stat_content.dataset.suffix;
					// 	}

					// 	let demo = new CountUp(stat_content, parseFloat(number), args);
					// 	if (!demo.error) {
					// 		demo.start();
					// 	} else {
					// 		console.warn(demo.error);
					// 	}
					// }
                },
                scrollContainer: null,
                resetAnimation: true
            }
        ).init();

		//Allow user to interrupt auto-scrolling
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$(document.scrollingElement).stop();
			}
		});
		CookieMenu.init();
		Menu.init();
		new Dropdown();
		if(window.innerWidth > 1200) {
			ListSplit.init('footer-nav', '.footer__header-nav');
		}
		Accordion.init();
		InfoButtons.init();
		MapPopover.init();
		TextArea.init();
		StickyMenu.init();
		GetConnected.init();
		ArticleSignUp.init();
		LEAS.init();
		TableSort.init();
		RegisterModal.init();
		Blog.init();
		Register.init();
		MultiDropdown.init();
		ScrollButtons.init();
		ProfilePicturePreview.init();
		LineClamp.init();
		Header.init();
		FeatureGrid.init('feature-block__image');
		FeatureGrid.init('register-header__image')
		Key.init();
		TableInfo.init();
		BackToTop.init();
		NetworkMasonry.init();
		Popup.init();
		// new LogoGrid('logo-grid__logo', 12, 'animate__zoomOut', 'animate__zoomIn', 3000)
		// Login.init();
		let locations = new Locations('#school-map');

		//if using ACF to search using_acf = 1
		const ACF = 1;
		//if using a custom taxonomy to search using_acf = 0
		const CUSTOM_TAXONOMY = 0;
		//if using a category to search using acf = 2
		const CATEGORY = 2;
		//is using a post type to search (ACF block)
		const POST_TYPE = 3;

		const POST_OBJECT = 4;

		if (document.querySelector("#posts-content") !== null) {
			const ajax = new Ajax('posts', 16, document.querySelector("#posts-content"), 1);
			ajax.init();
			ajax.addRadioButtons(document.querySelectorAll('#author-dropdown input'), 'author_id');
			ajax.addRadioButtons(document.querySelectorAll('#category-dropdown input'), 'categories');
			ajax.addLoadMoreButton(document.getElementById('load-more'));
			ajax.addTextInput(document.getElementById('post-search'));
			ajax.addNoResultsElement(document.getElementById('no-results'));
			console.log(ajax.getRoute());
		}

		if (document.querySelector("#research-content") !== null) {
			const researchAjax = new Ajax('research', 50, document.querySelector("#research-content"), 1);
			researchAjax.init();
			researchAjax.addRadioButtons(document.querySelectorAll('#source-dropdown input'), 'source');
			researchAjax.addRadioButtons(document.querySelectorAll('#category-dropdown input'), 'categories');
			researchAjax.addLoadMoreButton(document.getElementById('load-more'));
			researchAjax.addTextInput(document.getElementById('research-search'), ['author_search']);
			researchAjax.addNoResultsElement(document.getElementById('no-results'));
		}

		if (document.querySelector("#news-content") !== null) {
			const newsAjax = new Ajax('news', 16, document.querySelector("#news-content"), 1);
			newsAjax.init();
			newsAjax.addRadioButtons(document.querySelectorAll('#source-dropdown input'), 'source');
			newsAjax.addRadioButtons(document.querySelectorAll('#category-dropdown input'), 'categories');
			newsAjax.addLoadMoreButton(document.getElementById('load-more'));
			newsAjax.addTextInput(document.getElementById('news-search'));
			newsAjax.addNoResultsElement(document.getElementById('no-results'));
		}


		//if we are on the blog page.
		// if($('body').hasClass('page-id-41')) {
		// 	let inital_quantity = 16;
		// 	let load_more_quantity = 8;
		// 	let current_quantity = inital_quantity;
		//
		// 	// let options = {
		// 	// 	post_type: '',
		// 	// 	posts_per_page: current_quantity,
		// 	// 	curr_page: 1,
		// 	// 	category: '',
		// 	// 	value: '',
		// 	// 	taxonomy: '',
		// 	// 	using_acf: POST_OBJECT,
		// 	// 	container: 'content',
		// 	// 	order: true,
		// 	// 	blog_type: 'image',
		// 	// 	post_name: '',
		// 	// }
		//
		// 	let options = {
		// 		is_user: false,
		// 		post_type: 'post',
		// 		posts_per_page: current_quantity,
		// 		sorted: false,
		// 		container: 'content',
		// 		load_more_button: true,
		// 		load_more_button_id: 'load-more',
		// 		order_by: 'publish_date',
		// 		order: "DESC",
		// 		loading: false,
		// 	}
		//
		// 	let category_post_input = document.getElementById('category_post');
		// 	if(category_post_input) {
		// 		// let featured = document.getElementById('featured');
		// 		// if(featured) {
		// 		// 	featured.style.display = "none";
		// 		// }
		// 		let term_dropdown = document.getElementById('term');
		// 		if(term_dropdown) {
		// 			let container = term_dropdown.parentElement;
		// 			term_dropdown.value = category_post_input.value
		// 			Dropdown.drawOptions(container, undefined, true);
		// 		}
		// 		options.categories = [
		// 			{
		// 				name: 'category',
		// 				value: category_post_input.value
		// 			}
		// 		];
		// 	}
		//
		// 	let author_post_input = document.getElementById('author_post');
		// 	if(author_post_input) {
		// 		// let featured = document.getElementById('featured');
		// 		// if(featured) {
		// 		// 	featured.style.display = "none";
		// 		// }
		// 		let user_dropdown = document.getElementById('user');
		// 		if(user_dropdown) {
		// 			let container = user_dropdown.parentElement;
		// 			user_dropdown.value = author_post_input.value
		// 			Dropdown.drawOptions(container, undefined, true);
		// 		}
		// 		// options.category = 'authors';
		// 		// options.post_name = 'author';
		// 		// options.using_acf = POST_OBJECT;
		// 		// options.value = author_post_input.value;
		// 		let input_value = author_post_input.value;
		// 		options.acf_filters = [
		// 			{
		// 				post_type: "authors",
		// 				name: "author",
		// 				value: input_value,
		// 			},
		// 		];
		// 	}
		//
		// 	var news_ajax = new WPAjax(options)
		//
		// 	let load_more_button = document.getElementById('load-more');
		// 	load_more_button.addEventListener('click', function(e) {
		// 		current_quantity = current_quantity + load_more_quantity;
		// 		options.posts_per_page = current_quantity;
		// 		options.loading = true;
		// 		news_ajax = new WPAjax(options);
		// 	})
		//
		// 	$('#term').change(function(e) {
		// 		// options.order_by = 'category';
		// 		// options.order_value = e.target.value;
		// 		// options.order_type = '';
		// 		options.categories = [
		// 			{
		// 				name: 'category',
		// 				value: e.target.value
		// 			}
		// 		];
		// 		// options.using_acf = CATEGORY
		// 		options.loading = false;
		// 		news_ajax = new WPAjax(options);
		// 	})
		//
		// 	$('#user').change(function(e) {
		// 		options.acf_filters = [
		// 			{
		// 				post_type: "authors",
		// 				name: "author",
		// 				value: e.target.value
		// 			},
		// 		];
		// 		options.loading = false;
		// 		news_ajax = new WPAjax(options);
		// 	})
		//
		// 	var typingTimer;                //timer identifier
		// 	var doneTypingInterval = 1000;  //time in ms, 5 second for example
		//
		// 	//on keyup, start the countdown
		// 	$('#search').on('keyup', function () {
		// 		clearTimeout(typingTimer);
		// 		typingTimer = setTimeout(doneTyping, doneTypingInterval);
		// 	});
		//
		// 	//on keydown, clear the countdown
		// 	$('#search').on('keydown', function () {
		// 		// console.log("Key is down :)");
		// 		clearTimeout(typingTimer);
		// 	});
		//
		// 	//user is "finished typing," do something
		// 	function doneTyping () {
		// 		let input_value = $('#search').val();
		// 		console.log("User has entered: " + input_value);
		// 		options.search = input_value;
		// 		options.loading = false;
		// 		news_ajax = new WPAjax(options)
		// 		options.search_type = "and";
		//
		// 	}
		// }

		//
		//if we are on the news page.
		// if($('body').hasClass('page-id-32')) {
		// 	let inital_quantity = 16;
		// 	let load_more_quantity = 8;
		// 	let current_quantity = inital_quantity;
		//
		// 	// let options = {
		// 	// 	post_type: 'news',
		// 	// 	posts_per_page: current_quantity,
		// 	// 	curr_page: 1,
		// 	// 	category: '',
		// 	// 	value: '',
		// 	// 	taxonomy: '',
		// 	// 	using_acf: CUSTOM_TAXONOMY,
		// 	// 	container: 'content',
		// 	// 	order: true
		// 	// }
		//
		// 	var theme = {};
		// 	var source = {};
		//
		// 	let options = {
		// 		is_user: false,
		// 		posts_per_page: current_quantity,
		// 		categories: [theme, source],
		// 		post_type: 'news',
		// 		sorted: false,
		// 		container: 'content',
		// 		load_more_button: true,
		// 		load_more_button_id: 'load-more',
		// 		order_by: 'publish_date',
		// 		order: 'DESC',
		// 		exclude: true,
		// 		loading: false,
		// 	}
		//
		// 	let category_post_input = document.getElementById('category_post');
		// 	if(category_post_input) {
		// 		// let featured = document.getElementById('featured');
		// 		// if(featured) {
		// 		// 	featured.style.display = "none";
		// 		// }
		//
		// 		let term_dropdown = document.getElementById('term');
		// 		if(term_dropdown) {
		// 			let container = term_dropdown.parentElement;
		// 			term_dropdown.value = category_post_input.value
		// 			Dropdown.drawOptions(container, undefined, true);
		// 		}
		//
		// 		theme = {
		// 			name: 'category',
		// 			value: category_post_input.value
		// 		}
		//
		// 		options.categories = [theme, source];
		// 		options.exclude = false;
		// 	}
		//
		// 	let author_post_input = document.getElementById('author_post');
		// 	if(author_post_input) {
		// 		// let featured = document.getElementById('featured');
		// 		// if(featured) {
		// 		// 	featured.style.display = "none";
		// 		// }
		//
		// 		let user_dropdown = document.getElementById('source');
		// 		if(user_dropdown) {
		// 			let container = user_dropdown.parentElement;
		// 			user_dropdown.value = author_post_input.value
		// 			Dropdown.drawOptions(container, undefined, true);
		// 		}
		//
		// 		source = {
		// 			name: 'source',
		// 			value: author_post_input.value
		// 		};
		//
		// 		options.categories = [theme, source];
		// 		options.exclude = false;
		// 	}
		//
		// 	var news_ajax = new WPAjax(options)
		//
		// 	let load_more_button = document.getElementById('load-more');
		// 	load_more_button.addEventListener('click', function(e) {
		// 		current_quantity = current_quantity + load_more_quantity;
		// 		options.posts_per_page = current_quantity;
		// 		options.loading = true;
		// 		news_ajax = new WPAjax(options);
		// 	})
		//
		// 	$('#term').change(function(e) {
		// 		theme = {
		// 			name: 'category',
		// 			value: e.target.value
		// 		}
		// 		options.categories = [theme, source];
		//
		// 		options.theme = e.target.value;
		// 		options.loading = false;
		//
		// 		if(e.target.value === "All" && (!author_post_input && !category_post_input)) {
		// 			options.exclude = true;
		// 			if(options.term) {
		// 				news_ajax.get_news_by_search(options)
		// 			} else {
		// 				news_ajax = new WPAjax(options);
		// 			}
		// 		} else {
		// 			options.exclude = false;
		// 			if(options.term) {
		// 				news_ajax.get_news_by_search(options)
		// 			} else {
		// 				news_ajax = new WPAjax(options);
		// 			}
		// 		}
		//
		// 		// news_ajax = new WPAjax(options);
		// 	})
		//
		// 	$('#source').change(function(e) {
		// 		source = {
		// 			name: 'source',
		// 			value: e.target.value
		// 		};
		// 		let categories = [];
		// 		options.categories = [theme, source];
		//
		// 		options.publication = e.target.value;
		//
		// 		options.loading = false;
		//
		// 		if(e.target.value === "All" && (!author_post_input && !category_post_input)) {
		// 			options.exclude = true;
		// 			if(options.term) {
		// 				news_ajax.get_news_by_search(options)
		// 			} else {
		// 				news_ajax = new WPAjax(options);
		// 			}
		//
		// 		} else {
		// 			options.exclude = false;
		// 			if(options.term) {
		// 				news_ajax.get_news_by_search(options)
		// 			} else {
		// 				news_ajax = new WPAjax(options);
		// 			}
		// 		}
		//
		// 		// news_ajax = new WPAjax(options);
		// 	});
		//
		// 	var typingTimer;                //timer identifier
		// 	var doneTypingInterval = 1000;  //time in ms, 5 second for example
		//
		// 	//on keyup, start the countdown
		// 	$('#search').on('keyup', function () {
		// 		clearTimeout(typingTimer);
		// 		typingTimer = setTimeout(doneTyping, doneTypingInterval);
		// 	});
		//
		// 	//on keydown, clear the countdown
		// 	$('#search').on('keydown', function () {
		// 		// console.log("Key is down :)");
		// 		clearTimeout(typingTimer);
		// 	});
		//
		// 	//user is "finished typing," do something
		// 	function doneTyping () {
		// 		let input_value = $('#search').val();
		// 		console.log("User has entered: " + input_value);
		// 		options.search = input_value;
		// 		source = {
		// 			name: 'source',
		// 			value: input_value,
		// 			compare: 'like'
		// 		}
		//
		// 		options.loading = false;
		// 		options.categories = [source, theme];
		// 		options.search_type = "or";
		// 		options.acf_relationship = "or";
		// 		// options.search_category_and_acf = t
		// 		// options.categories = [];
		// 		options.sorted = false;
		// 		// options.acf_filters = [
		// 		// 	{
		// 		// 		name: 'source',
		// 		// 		value: input_value,
		// 		// 		compare: 'like'
		// 		// 	},
		// 		// 	{
		// 		// 		name: 'abbreviations',
		// 		// 		value: input_value,
		// 		// 		compare: 'like'
		// 		// 	}
		// 		// ];
		//
		// 		// options.acf_filters = [
		// 		// 	{
		// 		// 		name: 'authors',
		// 		// 		value: input_value,
		// 		// 		compare: 'like'
		// 		// 	},
		// 		// 	{
		// 		// 		name: 'abbreviations',
		// 		// 		value: input_value,
		// 		// 		compare: 'like'
		// 		// 	}
		// 		// ];
		// 		options.term = input_value;
		// 		// news_ajax = new WPAjax(options)
		// 		news_ajax.get_news_by_search(options)
		// 	}
		// }

		//if we are on the research page then we want to search the blog posts.
		// if($('body').hasClass('page-id-38')) {
		// 	// console.log("On the research page :)");
		// 	let inital_quantity = -1;
		// 	// let options = {
		// 	// 	post_type: 'research',
		// 	// 	posts_per_page: inital_quantity,
		// 	// 	curr_page: 1,
		// 	// 	category: '',
		// 	// 	value: '',
		// 	// 	taxonomy: '',
		// 	// 	using_acf: CATEGORY,
		// 	// 	container: 'blog-grid-content',
		// 	// 	order: true,
		// 	// 	order_by: '',
		// 	// 	order_value: '',
		// 	// }
		// 	let author = {};
		// 	let theme = {};
		// 	let that = this;
		//
		// 	let options = {
		// 		is_user: false,
		// 		post_type: 'research',
		// 		posts_per_page: inital_quantity,
		// 		container: 'blog-grid-content',
		// 		load_more_button: false,
		// 		order_by: 'publish_date',
		// 		order: "DESC",
		// 		loading: false,
		// 		// load_more_button_id: 'post-grid-button'
		// 	}
		//
		//
		// 	let blog_ajax = new WPAjax(options)
		//
		// 	// let button = document.getElementById('post-grid-button');
		// 	// button.addEventListener('click', async function(e) {
		// 	// 	options.posts_per_page = -1;
		// 	// 	button.style.display = 'none';
		// 	// 	blog_ajax = await new WPAjax(options);
		// 	// 	//posts-grid__border
		// 	// 	button.parentElement.nextElementSibling.style.display = "none";
		//
		// 	// 	//last item in post grid
		// 	// 	console.log("Removing borders :)");
		// 	// 	let last_research = document.getElementById('blog-grid-content').lastElementChild.getElementsByClassName("post-item")[0]
		// 	// 	last_research.style.borderBottom = 'none';
		// 	// });
		//
		// 	$('#term').change(function(e) {
		// 		options.categories = [
		// 			{
		// 				name: 'category',
		// 				value: e.target.value
		// 			}
		// 		];
		// 		options.loading = false;
		// 		document.getElementById('search').value = "";
		// 		delete options.search;
		// 		delete options.search_type;
		// 		delete options.acf_relationship
		// 		delete options.acf_filters;
		//
		// 		// options.sorted = true;
		// 		blog_ajax = new WPAjax(options);
		// 	})
		//
		// 	$("#source").change(function(e) {
		// 		options.categories = [
		// 			{
		// 				name: 'source',
		// 				value: e.target.value
		// 			}
		// 		];
		//
		// 		options.loading = false;
		// 		document.getElementById('search').value = "";
		// 		delete options.search;
		// 		delete options.search_type;
		// 		delete options.acf_relationship
		// 		delete options.acf_filters;
		//
		// 		// options.sorted = true;
		// 		blog_ajax = new WPAjax(options);
		// 	})
		//
		// 	var typingTimer;                //timer identifier
		// 	var doneTypingInterval = 1000;  //time in ms, 5 second for example
		//
		// 	//on keyup, start the countdown
		// 	$('#search').on('keyup', function () {
		// 		Dropdown.reset_this(document.getElementById('term'));
		// 		Dropdown.reset_this(document.getElementById('source'));
		// 		clearTimeout(typingTimer);
		// 		typingTimer = setTimeout(doneTyping, doneTypingInterval);
		// 	});
		//
		// 	//on keydown, clear the countdown
		// 	$('#search').on('keydown', function () {
		// 		// console.log("Key is down :)");
		// 		clearTimeout(typingTimer);
		// 	});
		//
		// 	//user is "finished typing," do something
		// 	function doneTyping () {
		// 		let input_value = $('#search').val();
		// 		console.log("User has entered: " + input_value);
		// 		options.search = input_value;
		// 		options.search_type = "or";
		// 		options.acf_relationship = "or";
		// 		options.categories = [];
		// 		options.sorted = false;
		// 		options.posts_per_page = -10000;
		// 		options.loading = false;
		// 		options.acf_filters = [
		// 			{
		// 				name: 'authors',
		// 				value: input_value,
		// 				compare: 'like'
		// 			},
		// 			{
		// 				name: 'abbreviations',
		// 				value: input_value,
		// 				compare: 'like'
		// 			}
		// 		];
		// 		// options.sorted = true;
		// 		blog_ajax = new WPAjax(options)
		// 	}
		// }

		let changes_holder = document.getElementById('changes-content');
		if(changes_holder) {
			let current_quantity = -1;

			let term = {};

			let options = {
				is_user: false,
				post_type: 'changes',
				posts_per_page: current_quantity,
				curr_page: 1,
				categories: [term],
				container: 'changes-content',
				sorted: false,
				load_more_button: false,
				order_by: 'menu_order',
				order: 'ASC',
				loading: false,
				// order: 'ASC'
			}

			var news_ajax = new WPAjax(options)


			$('#term').change(function(e) {
				term = {
					name: 'category',
					value: e.target.value
				};
				options.categories = [term];
				news_ajax = new WPAjax(options)
			})


			var typingTimer;                //timer identifier
			var doneTypingInterval = 1000;  //time in ms, 5 second for example

			//on keyup, start the countdown
			$('#search').on('keyup', function () {
				clearTimeout(typingTimer);
				typingTimer = setTimeout(doneTyping, doneTypingInterval);
			});

			//on keydown, clear the countdown
			$('#search').on('keydown', function () {
				// console.log("Key is down :)");
				clearTimeout(typingTimer);
			});

			//user is "finished typing," do something
			function doneTyping () {
				let input_value = $('#search').val();
				console.log("User has entered: " + input_value);
				options.search = input_value;
				news_ajax = new WPAjax(options)
			}
		}

		if($('body').hasClass('page-id-668') || $('body').hasClass('page-id-466')) {
		// if($('body').hasClass('page-id-466')) {
			let initial_quantity = 20;
			let load_more_quantity = 6;
			let current_quantity = initial_quantity;

			// let options = {
			// 	post_type: 'users',
			// 	posts_per_page: current_quantity,
			// 	curr_page: 1,
			// 	category: '',
			// 	value: '',
			// 	taxonomy: '',
			// 	using_acf: POST_TYPE,
			// 	container: 'network-content',
			// }

			let options = {
				is_user: true,
				posts_per_page: current_quantity,
				container: 'network-content',
				load_more_button: true,
				load_more_button_id: 'load-more-profiles'
			}

			if(Cookies.get('searchPostType') === 'network') {
				let search = Cookies.get('searchTerm');
				let searchBox = document.querySelector('#search');
				if(searchBox) {
					searchBox.value = search;
				}

				options.user_details = [
					{
						name: 'first_name',
						value: search
					},
					{
						name: 'last_name',
						value: search
					},
					{
						name: 'display_name',
						value: search
					}
				];


			}

			let network_ajax = new WPAjax(options);

			let load_more = document.getElementById('load-more-profiles');
			load_more.addEventListener('click', (e) => {
				current_quantity += load_more_quantity;
				options.posts_per_page = current_quantity;
				options.loading = true;
				network_ajax = new WPAjax(options);
			})

			var doneTypingInterval = 1000;  //time in ms, 5 second for example

			//on keyup, start the countdown
			$('#search').on('keyup', function () {
				clearTimeout(typingTimer);
				typingTimer = setTimeout(doneTyping, doneTypingInterval);
			});

			//on keydown, clear the countdown
			$('#search').on('keydown', function () {
				// console.log("Key is down :)");
				clearTimeout(typingTimer);
			});

			//user is "finished typing," do something
			function doneTyping () {
				let input_value = $('#search').val();
				console.log("User has entered: " + input_value);
				// options.search = input_value;
				options.user_details = [
					{
						name: 'first_name',
						value: input_value
					},
					{
						name: 'last_name',
						value: input_value
					},
					{
						name: 'display_name',
						value: input_value
					}
				]
				options.loading = false;
				news_ajax = new WPAjax(options)
			}

			var checkbox_timer;                //timer identifier
			var checkbox_timer_interval = 1000;  //time in ms, 5 second for example
			var values;
			let la_values;
			let work_area_values;
			let interest_values;
			var category;

			let inputs = document.querySelectorAll('input[name="contact"]');
			for(let i = 0; i < inputs.length; i++) {
				let option = inputs[i].parentElement.parentElement;
				option.addEventListener('click', (e) => {
					values = MultiDropdown.get_values("contact");
					interest_values = values;
					category = "contact_areas";
					clearTimeout(checkbox_timer);
					options.category = 'contact_areas';
					options.is_repeater = true;
					checkbox_timer = setTimeout(check_timer, checkbox_timer_interval);
				})
			}

			let work_inputs = document.querySelectorAll('input[name="work-areas"]');
			for(let i = 0; i < work_inputs.length; i++) {
				let option = work_inputs[i].parentElement.parentElement;
				option.addEventListener('click', (e) => {
					values = MultiDropdown.get_values("work-areas");
					work_area_values = values;
					if(e.target.value === "All AP") {
						setTimeout(() => {
							values = MultiDropdown.get_values("work-areas");
							work_area_values = values;
						}, 50)
					}
					category = "work_areas"
					options.category = 'work_areas';
					options.is_repeater = true;
					clearTimeout(checkbox_timer);
					checkbox_timer = setTimeout(check_timer, checkbox_timer_interval);
				})
			}

			let las = document.querySelectorAll('input[name="las"]');
			for(let i = 0; i < las.length; i++) {
				let option = las[i].parentElement.parentElement;
				option.addEventListener('click', (e) => {
					values = MultiDropdown.get_values("las");
					category = "las"
					la_values = values;
					options.category = 'las';
					options.is_repeater = true;
					clearTimeout(checkbox_timer);
					checkbox_timer = setTimeout(check_timer, checkbox_timer_interval);
				})
			}
			// let local_authority_inputs = document.querySelectorAll('input[name="la"]');
			// for(let i = 0; i < local_authority_inputs.length; i++) {
			// 	let option = local_authority_inputs[i].parentElement.parentElement;
			// 	option.addEventListener('click', (e) => {
			// 		values = MultiDropdown.get_values("la");
			// 		options.is_repeater = false;
			// 		category = "local_authority"
			// 		options.category = 'local_authority';
			// 		clearTimeout(checkbox_timer);
			// 		checkbox_timer = setTimeout(check_timer, checkbox_timer_interval);
			// 	})
			// }

			$('#la').change(function(e) {
				options.is_repeater = false;
				category = "local_authority"
				options.category = 'local_authority';
				options.categories = [theme, source];
				options.acf_filters = [
					{
						name: category,
						value: (e.target.value === "National") ? '' : e.target.value
					}
				]
				options.loading = false;
				news_ajax = new WPAjax(options);
			})

			function check_timer() {
				const index = values.indexOf('All AP');
				if (index > -1) {
					values.splice(index, 1);
				}
				console.log("Values: ", values);
				// console.log("Work area values: ", work_area_values);
				// options.acf_filters = [];

				//getting the LAs,


				//getting the interests

				//getting the work areas

				// for(let i = 0; i < values.length; i++) {
				// 	options.acf_filters.push({
				// 		name: category,
				// 		value: values[i]
				// 	})
				// 	if(values[i] === "National") {
				// 		options.acf_filters = [];
				// 		values = [];
				// 		break;
				// 	}
				// }

				options.las = la_values;
				options.work_areas = work_area_values;
				options.contact_areas = interest_values;

				options.value = values
				options.using_acf = POST_TYPE;

				options.loading = false;
				network_ajax = new WPAjax(options)
			}
		}

		//if we are on the news page.
		if($('body').hasClass('page-id-345')) {
			let inital_quantity = 5;
			let load_more_quantity = 5;
			let current_quantity = -1;

			let status = {};
			let term = {};

			let options = {
				is_user: false,
				post_type: 'TimpsonTracker',
				posts_per_page: current_quantity,
				curr_page: 1,
				categories: [status, term],
				container: 'accordion-content',
				sorted: false,
				load_more_button: false,
				order_by: 'menu_order',
				order: 'DESC'
			}

			var news_ajax = new WPAjax(options)

			// let status_dropdown = document.getElementById('status_dropdown');
			$('#status_dropdown').change(function(e) {
				status = {
					name: 'status',
					value: e.target.value
				}
				options.categories = [status, term];
				news_ajax = new WPAjax(options)
			});

			$('#term').change(function(e) {
				term = {
					name: 'category',
					value: e.target.value
				};
				options.categories = [status, term];
				news_ajax = new WPAjax(options)
			})

			// let load_more_button = document.getElementById('load-more');
			// load_more_button.addEventListener('click', function(e) {
			// 	current_quantity = current_quantity + load_more_quantity;
			// 	options.posts_per_page = current_quantity;
			// 	news_ajax = new WPAjax(options);
			// })

			var typingTimer;                //timer identifier
			var doneTypingInterval = 1000;  //time in ms, 5 second for example

			//on keyup, start the countdown
			$('#search').on('keyup', function () {
				clearTimeout(typingTimer);
				typingTimer = setTimeout(doneTyping, doneTypingInterval);
			});

			//on keydown, clear the countdown
			$('#search').on('keydown', function () {
				// console.log("Key is down :)");
				clearTimeout(typingTimer);
			});

			//user is "finished typing," do something
			function doneTyping () {
				let input_value = $('#search').val();
				console.log("User has entered: " + input_value);
				options.search = input_value;
				news_ajax = new WPAjax(options)
			}
		}

		if(document.querySelector('.page-id-4772')) {
			let inital_quantity = 16;
			let load_more_quantity = 8;
			let current_quantity = inital_quantity;

			var theme = {};
			var source = {};

			let options = {
				is_user: false,
				posts_per_page: current_quantity,
				categories: [theme, source],
				post_type: 'videos',
				sorted: false,
				container: 'content',
				load_more_button: true,
				load_more_button_id: 'load-more',
				order_by: 'publish_date',
				order: 'DESC',
				exclude: true,
				loading: false,
			}

			let category_post_input = document.getElementById('category_post');
			if(category_post_input) {
				let term_dropdown = document.getElementById('term');
				if(term_dropdown) {
					let container = term_dropdown.parentElement;
					term_dropdown.value = category_post_input.value
					Dropdown.drawOptions(container, undefined, true);
				}

				theme = {
					name: 'category',
					value: category_post_input.value
				}

				options.categories = [theme, source];
				options.exclude = false;
			}

			let author_post_input = document.getElementById('author_post');
			if(author_post_input) {
				let user_dropdown = document.getElementById('source');
				if(user_dropdown) {
					let container = user_dropdown.parentElement;
					user_dropdown.value = author_post_input.value
					Dropdown.drawOptions(container, undefined, true);
				}

				source = {
					name: 'source',
					value: author_post_input.value
				};

				options.categories = [theme, source];
				options.exclude = false;
			}

			var news_ajax = new WPAjax(options)

			let load_more_button = document.getElementById('load-more');
			load_more_button.addEventListener('click', function(e) {
				current_quantity = current_quantity + load_more_quantity;
				options.posts_per_page = current_quantity;
				options.loading = true;
				news_ajax = new WPAjax(options);
			})

			$('#term').change(function(e) {
				theme = {
					name: 'category',
					value: e.target.value
				}
				options.categories = [theme, source];

				options.theme = e.target.value;
				options.loading = false;

				if(e.target.value === "All" && (!author_post_input && !category_post_input)) {
					options.exclude = true;
					if(options.term) {
						news_ajax.get_news_by_search(options)
					} else {
						news_ajax = new WPAjax(options);
					}
				} else {
					options.exclude = false;
					if(options.term) {
						news_ajax.get_news_by_search(options)
					} else {
						news_ajax = new WPAjax(options);
					}
				}

				// news_ajax = new WPAjax(options);
			})

			$('#source').change(function(e) {
				source = {
					name: 'source',
					value: e.target.value
				};
				let categories = [];
				options.categories = [theme, source];

				options.publication = e.target.value;

				options.loading = false;

				if(e.target.value === "All" && (!author_post_input && !category_post_input)) {
					options.exclude = true;
					if(options.term) {
						news_ajax.get_news_by_search(options)
					} else {
						news_ajax = new WPAjax(options);
					}

				} else {
					options.exclude = false;
					if(options.term) {
						news_ajax.get_news_by_search(options)
					} else {
						news_ajax = new WPAjax(options);
					}
				}

			});

			var typingTimer;                //timer identifier
			var doneTypingInterval = 1000;  //time in ms, 5 second for example

			//on keyup, start the countdown
			$('#search').on('keyup', function () {
				clearTimeout(typingTimer);
				typingTimer = setTimeout(doneTyping, doneTypingInterval);
			});

			//on keydown, clear the countdown
			$('#search').on('keydown', function () {
				// console.log("Key is down :)");
				clearTimeout(typingTimer);
			});

			//user is "finished typing," do something
			function doneTyping () {
				let input_value = $('#search').val();
				console.log("User has entered: " + input_value);
				options.search = input_value;
				source = {
					name: 'source',
					value: input_value,
					compare: 'like'
				}

				options.loading = false;
				options.categories = [source, theme];
				options.search_type = "or";
				options.acf_relationship = "or";
				options.sorted = false;
				options.term = input_value;
				// news_ajax = new WPAjax(options)
				news_ajax.get_news_by_search(options)
			}
		}

		$('#ofsted').change(function(event) {
			console.log("Ofsted changed :)");
			locations.ofsted_dropdown(event.target.value);
		});

		if(Cookies.get('searchPostType')) {
			let id = Cookies.get('searchId');
			let searchTerm = Cookies.get('searchTerm');
			switch(Cookies.get('searchPostType')) {
				case "partner" :
					let el = document.querySelector(`*[data-id='${id}']`);
					if(el) {
						const y = el.getBoundingClientRect().top + window.pageYOffset + -150;
						window.scrollTo({top: y, behavior: 'smooth'});
						let instance = new Mark(el);
						instance.mark(searchTerm);
					}

					Cookies.remove('searchTerm')
					Cookies.remove('searchPostType');
					Cookies.remove('searchId');
					break;
				case "page" :
				case "videos" :
				case "post" :
				case "news" :
					let instance = new Mark(document.body.querySelectorAll('*'));
					instance.mark(searchTerm, {
						"done": function (counter) {
							let mark = document.querySelector('mark');
							const y = mark.getBoundingClientRect().top + window.pageYOffset + -200;
							window.scrollTo({top: y, behavior: 'smooth'});
						}
					});

					Cookies.remove('searchTerm')
					Cookies.remove('searchPostType');
					Cookies.remove('searchId');
					break;
			}
		}

	},

	//Prefer creating new modules when appropriate, rather than adding functions here
	//If you need something to be globally accessible, you can assign an imported module to this namespace
	//I.e import Contact from './contact';
	//    window.namespace.Contact = Contact;
};

window.namespace.init();

// SVG Sprite Loader
// eslint-disable-next-line no-unused-vars
const __sprite__ = {
	path: '../../resources/images/icons/**/*.svg', //Source SVGs path relative to the compiled js (dist/js)
	name: 'images/icons.svg', //Compiled file path relative to dist/
};

svgxhr({
	filename: './wp-content/themes/class/dist/images/icons.svg', //URL to fetch
});
